<script setup lang="ts">
import type { HTMLAttributes } from "vue";
import { cn } from "@/lib/utils";

const props = defineProps<{
    class?: HTMLAttributes["class"];
}>();
</script>

<template>
    <div class="relative w-full overflow-auto">
        <table :class="cn('text-sm w-full caption-bottom', props.class)">
            <slot />
        </table>
    </div>
</template>
